import React, { useState, useEffect, useLayoutEffect } from "react";
import "./GetStarted.scss"
import "../../Home.scss";
import "../../../../styles/styles.css";
import DITYPES from "../../../../config/di.types";
import UtilService from "../../../../services/UtilService";
import DIContainer from "../../../../config/di.container";
import { useFlags } from 'launchdarkly-react-client-sdk';


const utilService = DIContainer.get<UtilService>(DITYPES.UtilService);
const GetStarted: React.FC = () => {

  const { showConsumerApiUiChanges } = useFlags();
  const PUBLIC_URL = process.env.PUBLIC_URL;
  const [isMobileViewOne, setIsMobileView] = useState(utilService.checkIsMobileView);
  let [content, setContent] = useState<any>(undefined);

  const handleResize = () => {
    setIsMobileView(utilService.checkIsMobileView());
  }

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    rendererElements();
  }, [isMobileViewOne])

  const rendererElements = () => {
    let tempContent: any[] = [];
    if (isMobileViewOne) {
      tempContent.push(imgSection);
      tempContent.push(textSection);
    }
    else {
      tempContent.push(textSection);
      tempContent.push(imgSection);
    }
    setContent(tempContent);
  }

  var textSection = (<div key="text-sec-key" className="row-right col-md-pad">
    <div className="row row-mb">
      <div className="get-started-img">
        <img className="icon1 icon1-img"
          alt="get-started-icon-1"
        ></img>
      </div>
      <div className="col-md-10 col-mb-gs-10">
        <h4 className="getting-started-h2">Create your account</h4>
        <p className="getting-started-paragraph">
          Fill out a brief form to set up your free account and sandbox environment.
        </p>
      </div>
    </div>
    <div className="row">
      <div className="get-started-img">
        <img className="icon2 icon2-img"

          alt="get-started-icon-2"
        ></img>
      </div>
      <div className="col-md-10 col-mb-gs-10">
        {showConsumerApiUiChanges && <h4 className="getting-started-h2">Try before you build</h4>}
        {!showConsumerApiUiChanges && <h4 className="getting-started-h2">Use the sandbox</h4>}
        {showConsumerApiUiChanges && <p className="getting-started-paragraph">
          Start experimenting and testing your code before it goes live. Our free test environments makes it simple.
        </p>}
        {!showConsumerApiUiChanges && <p className="getting-started-paragraph">
          Start experimenting and testing your code before it goes live. Our free sandbox makes it simple.
        </p>}
      </div>
    </div>
    <div className="row">
      <div className="get-started-img">
        <img className="icon1 icon3-img"

          alt="get-started-icon-3"
        ></img>
      </div>
      <div className="col-md-10 col-mb-gs-10">
        <h4 className="getting-started-h2">Activate and launch</h4>
        <p className="getting-started-paragraph">
          Ready to go live ? Tell us about your integration, submit your
          request for the credentials and launch. IT’S THAT EASY.
        </p>
      </div>
    </div>
  </div>);

  var imgSection = (<div key="img-sec-key" className="row-left">
    <div className="col-md-12 getting-started-imgdiv">
      <img alt="get-started-bg-img"
        className="gettingstarted-bg get-started-bg-img"></img>
      <div className="getting-started-img2">
        <div>
          <div className="cred-text">
            <span >Your API credentials</span>
          </div>
        </div>
        <div className="source-text">
          <span >Source Name</span>
        </div>
        <div className="source-text developer-text">
          <span >Developer Testing</span>
        </div>
      </div>
    </div>
  </div>);

  return (
    <div className="getting-started-section">
      <h2 className="getting-started-heading">
        Getting started is quick and easy.
            </h2>
      <div className="row row-container">
        {content}
      </div>
      <div className="getstarted w-container w1-button-section">
        <a id="btn-started-view-start-build" href="/PublicDocumentation/V6" className="btn team3-left-button register w-button">
          Start Building
        </a>
      </div>
    </div>
  );
};

export default GetStarted;
